import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useCartBasicInfo } from "../../hooks/useCart";
import { useCartBtn } from "../../hooks/useCartBtn";
import { IcBtn } from "../button/IcBtn";
import Cart from "../Cart";
import { icCartOutline } from "../image/image-src";
export const HeaderCartBtn: React.FC<{
  vari?: "SM" | "BASE";
  ic?: string;
}> = ({ vari = "SM", ic }) => {
  const { data: cartBasicInfo } = useCartBasicInfo();
  const { isCartOpen, setIsCartOpen, cartRef } = useCartBtn();
  const [isActive,setIsActive] = useState(false);
  useEffect(() => {
    setIsActive(isCartOpen);
  }, [isCartOpen]);
  return (
    <>
      <div className="relative">
        <IcBtn
          vari={vari}
          onClick={() => {
            setIsActive(false);
            if (isActive) {
              setIsCartOpen(false);
              return;
            }
            setIsCartOpen(!isCartOpen)
          }}
          ic={ic ?? icCartOutline}      
        />
        {!!cartBasicInfo?.total && (
          <div
            className={clsx(
              "absolute flex size-[1.125rem] items-center justify-center rounded-full bg-[#DA3838] text-[0.875rem] font-semibold leading-[1.375rem] text-white",
              {
                "right-[-0.5rem] top-[-0.5rem]": vari === "SM",
                "right-0 top-0": vari === "BASE",
              },
            )}
          >
            {cartBasicInfo.total}
          </div>
        )}
      </div>
      {isCartOpen && (
        <div ref={cartRef} className="z-[9999999999] absolute right-0 mr-4 mt-8">
          <Cart onGoToCart={() => setIsCartOpen(false)} />
        </div>
      )}
    </>
  );
};
